<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="600px">
      <v-card>
        <v-toolbar elevation="0" color="background">
          <v-toolbar-title class="pl-3 text--subtitle">
            {{ $t('message.pages.warningPaymentIssues.title') }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text class="pl-7 pr-5 py-0">
          <v-row
            style="height: 320px"
            v-if="loadingInfo"
            no-gutters
            align="center"
            justify="center"
          >
            <loading-logo :value="200" />
          </v-row>
          <v-row no-gutters v-else-if="paymentSuccess">
            <v-col cols="12">
              <v-row
                class="flex-column"
                :class="isMobileBreakpoint ? '' : 'px-11'"
                no-gutters
                align="center"
                justify="center"
              >
                <v-icon size="64" color="#C8E6C9">mdi-check-circle</v-icon>
                <span class="paymentText textType2--text">{{
                  $t('message.pages.warningPaymentIssues.payment')
                }}</span>
                <span class="dateText textType--text">
                  {{ $t('message.pages.warningPaymentIssues.at')
                  }}{{ getDateThroughTimeStamp(new Date()) }}
                </span>
                <v-col cols="12" class="mt-6">
                  <v-row no-gutters justify="space-between">
                    <span>{{
                      $t('message.pages.warningPaymentIssues.bill')
                    }}</span>
                    <v-col
                      class="d-flex flex-row align-center justify-center shrink"
                    >
                      <span> {{ userInvoice.description }} </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12" class="my-3">
                  <v-divider />
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters justify="space-between">
                    <span>{{
                      $t('message.pages.warningPaymentIssues.expiry')
                    }}</span>
                    <span>{{
                      getDateThroughTimeStamp(userInvoice.period_end * 1000)
                    }}</span>
                  </v-row>
                </v-col>
                <v-col cols="12" class="my-3">
                  <v-divider />
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters justify="space-between">
                    <span>{{ $t('message.value') }}</span>
                    <span>{{
                      Number(userInvoice.total / 100).toLocaleString(
                        currencyLocale,
                        {
                          style: 'currency',
                          currency: currency,
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }
                      )
                    }}</span>
                  </v-row>
                </v-col>
                <v-col cols="12" class="my-3">
                  <v-divider />
                </v-col>
                <v-col cols="12">
                  <v-row no-gutters justify="space-between">
                    <span>{{
                      $t(
                        'message.pages.credits.creditsPaymentModal.paymentForm'
                      )
                    }}</span>
                    <span>{{
                      $t('message.pages.warningPaymentIssues.card')
                    }}</span>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters v-else>
            <v-col cols="12" v-if="errors.paymentErr">
              <v-alert dense color="#ffcdd3" width="100%">
                <v-row no-gutters class="align-center justify-start">
                  <v-icon class="mr-2" color="#b71d1c"
                    >mdi-close-octagon</v-icon
                  >
                  <span
                    class="footerText align-text d-block"
                    style="color: #c43c3e"
                  >
                    {{ errors.shownErrMsg }}
                  </span>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon size="18" v-bind="attrs" v-on="on">
                        mdi-help-circle
                      </v-icon>
                    </template>
                    <v-container
                      class="text-body-2 pa-0"
                      style="max-width: 230px"
                    >
                      {{ errors.errMsg }}
                    </v-container>
                  </v-tooltip>
                </v-row>
              </v-alert>
            </v-col>
            <v-col cols="12">
              <v-card width="100%" color="newBackground" flat>
                <v-row
                  no-gutters
                  justify="center"
                  align="center"
                  class="fill-height"
                >
                  <v-col cols="12" class="px-3 pt-4 pb-1">
                    <v-row no-gutters>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{ $t('message.pages.warningPaymentIssues.expiry') }}
                        </span>
                      </v-col>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{ $t('message.value') }}
                        </span>
                      </v-col>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{
                            $t('message.pages.warningPaymentIssues.situation')
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" class="px-3 pb-4">
                    <v-row no-gutters>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{
                            getDateThroughTimeStamp(
                              userInvoice.period_end * 1000
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{
                            Number(userInvoice.total / 100).toLocaleString(
                              currencyLocale,
                              {
                                style: 'currency',
                                currency: currency,
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )
                          }}
                        </span>
                      </v-col>
                      <v-col cols="4">
                        <span class="cartBenefitsText typeText2--text">
                          {{
                            $t(
                              'message.pages.warningPaymentIssues.pending'
                            ).toUpperCase()
                          }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12">
                    <v-divider />
                  </v-col>
                  <v-col cols="12" class="px-3 py-4">
                    <v-row no-gutters>
                      <span class="pr-3">{{
                        $t('message.pages.warningPaymentIssues.description')
                      }}</span>
                      <span>{{ userInvoice.description }}</span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" class="mt-6">
              <v-card height="79px" width="100%" color="newBackground" flat>
                <v-row
                  no-gutters
                  justify="center"
                  align="center"
                  class="fill-height px-3"
                >
                  <v-col cols="7">
                    <span class="cartBenefitsText typeText2--text">
                      <b
                        >{{
                          $t('message.pages.warningPaymentIssues.paymentForm')
                        }}
                      </b>
                    </span>
                  </v-col>
                  <v-col cols="5" class="d-flex justify-end">
                    <v-select-legacy
                      v-model="selectedItem"
                      :items="userPaymentMethods"
                      :menu-props="{ top: false, offsetY: true }"
                      dense
                      hide-details
                      outlined
                      flat
                      return-object
                    >
                      <template #selection="{ item }">
                        <template v-if="item && item.type === 'card'">
                          <v-card
                            style="padding-left: 2px"
                            outlined
                            width="35"
                            height="24"
                            class="rounded card-image d-flex align-center justify-center"
                          >
                            <v-img
                              v-if="item.brand"
                              :src="cardsImages[`${item.brand.toLowerCase()}`]"
                              max-width="35"
                              class="rounded card-image"
                            />
                          </v-card>
                          <span class="pl-2">
                            {{ capitalizeFirstLetter(item.brand) }}-{{
                              item.last4.trim()
                            }}</span
                          >
                        </template>
                        <template v-else>
                          {{ $t('message.pages.userPlan.ticket') }}
                        </template>
                      </template>
                      <template #item="{ item }">
                        <template v-if="item && item.type">
                          <span class="d-flex" v-if="item.type === 'card'">
                            <v-card
                              style="padding-left: 2px"
                              outlined
                              width="35"
                              height="24"
                              class="rounded card-image d-flex align-center justify-center"
                            >
                              <v-img
                                v-if="item.brand"
                                :src="
                                  cardsImages[`${item.brand.toLowerCase()}`]
                                "
                                max-width="35"
                                class="rounded card-image"
                              />
                            </v-card>
                            <span class="pl-2">
                              {{ capitalizeFirstLetter(item.brand) }}-{{
                                item.last4.trim()
                              }}</span
                            >
                          </span>
                          <span
                            v-if="item.type === 'other'"
                            @click="addCard"
                            style="cursor: pointer"
                          >
                            {{
                              $t('message.pages.warningPaymentIssues.addCard')
                            }}
                          </span>
                          <span
                            v-if="item.type === 'boleto'"
                            style="cursor: pointer"
                          >
                            {{ $t('message.pages.userPlan.ticket') }}
                          </span>
                        </template>
                      </template>
                    </v-select-legacy>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="px-8 py-6" v-if="!loadingInfo">
          <!-- <v-btn @click="fetchInfo">teste</v-btn> -->
          <v-spacer v-if="!paymentSuccess"></v-spacer>
          <v-btn
            v-if="paymentSuccess"
            color="primary"
            class="mx-auto px-4"
            @click="handleClose"
            >{{ $t('message.pages.warningPaymentIssues.finish') }}</v-btn
          >
          <v-btn
            class="primary white--text"
            min-width="185px"
            v-else-if="selectedItem && selectedItem.type === 'boleto'"
            @click="openLink(userInvoice.hosted_invoice_url)"
          >
            {{ $t('message.pages.warningPaymentIssues.downloadInvoice') }}
            <v-icon class="ml-2" size="18">mdi-open-in-new</v-icon>
          </v-btn>
          <v-btn
            v-else
            class="primary white--text"
            min-width="185px"
            :loading="isFetching"
            @click="handleConfirm"
          >
            {{ $t('message.pages.warningPaymentIssues.confirmPay') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import planApi from '@/services/planApi'
import invoiceApi from '@/services/invoiceApi'
import i18n from '@/translations/lang'
import LoadingLogo from '@/components/LoadingLogo.vue'
export default {
  name: 'WarningPaymentIssue',
  components: { LoadingLogo },
  data: () => ({
    open: false,
    isFetching: false,
    loadingInfo: false,
    paymentSuccess: false,
    payment: {
      type: 'boleto',
    },
    currency: 'brl',
    currencyLocale: 'pt-BR',
    selectedItem: null,
    userPaymentMethods: [],
    userDefaultCard: null,
    invoices: [],
    userInvoice: {},
    cardsImages: {
      mastercard:
        'https://js.stripe.com/v3/fingerprinted/img/mastercard-4d8844094130711885b5e41b28c9848f.svg',
      visa: 'https://js.stripe.com/v3/fingerprinted/img/visa-729c05c240c4bdb47b03ac81d9945bfe.svg',
      elo: 'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
      american_express:
        'https://js.stripe.com/v3/fingerprinted/img/elo-efe873e884e6c9eb817f23a120caaa3e.svg',
    },
    errors: {
      shownErrMsg: i18n.t(
        'message.pages.warningPaymentIssues.defaultPaymentError'
      ),
      paymentErr: '',
      errMsg: '',
    },
  }),
  watch: {},
  mounted() {
    this.$root.$on('openWarningPaymentIssue', () => {
      this.open = true
      this.setCurrencyConfig()
      this.fetchInfo()
    })
  },
  computed: {
    ...mapState({
      userPlanInfo: (state) => state.user.userPlanInfo,
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
  },
  beforeDestroy() {
    this.$root.$off('openWarningPaymentIssue')
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    addCard() {
      this.handleClose()
      this.$router.push({ name: 'UserPlan' }).catch((e) => {
        console.error(e)
      })
    },
    openLink(link) {
      return window.open(`${link}`, '_blank')
    },
    async fetchInfo() {
      this.loadingInfo = true
      await planApi.getCards().then(({ data }) => {
        this.userPaymentMethods = data.sources
        this.userPaymentMethods.push({ type: 'other' })
        this.userDefaultCard = data.sources.find((source) => source.default)
        this.selectedItem = data.sources.find(
          (source) => source.default ?? this.userPaymentMethods[0] ?? null
        )
      })
      await invoiceApi.getInvoices().then(({ data }) => {
        this.userInvoice = data.invoices.find(
          (invoice) => invoice.status !== 'paid'
        )
      })
      this.loadingInfo = false
    },
    async tryPaymentAgain() {
      if (this.selectedItem.id !== this.userDefaultCard.id) {
        await this.changeDefaultPayment(this.selectedItem.id)
      }
      try {
        this.forcePaymentLoading = true
        let ret = await planApi.forcePayment(this.userInvoice.id)
        this.forcePaymentLoading = false
        this.$root.$emit('refreshUserPlan')
        this.handleSnackbar(
          this.$t('message.navDrawer.forcePayment.successMessage')
        )
        return ret
      } catch (error) {
        this.handleFetchError(error)
      }
    },
    setCurrencyConfig() {
      const currency = this.userPlanInfo.userCurrency
      if (currency === 'usd') {
        this.currency = 'usd'
        this.currencyLocale = 'en-US'
        return
      } else {
        this.currency = 'brl'
        this.currencyLocale = 'pt-BR'
      }
    },
    capitalizeFirstLetter(string) {
      if (!string) return
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    async changeDefaultPayment(paymentId) {
      try {
        await planApi.changeDefaultCard(paymentId)
        this.paymentSuccess = true
      } catch (e) {
        this.handleFetchError(e)
      }
    },
    handleFetchError(err) {
      let errString = ''
      if (
        err?.response?.data &&
        err?.response?.data?.errMsg &&
        err?.response?.data?.errCode
      ) {
        errString =
          err.response.data.errCode + ' ' + err.response.data.errMsg.error
      }
      this.errors.paymentErr = true
      this.errors.errMsg =
        err.msg ?? errString ?? err.response.data.message ?? 'Error'
      if (err?.response?.data?.detail?.raw?.message) {
        this.errors.errMsg = err.response.data.detail.raw.message.errMsg
      }
    },
    handleSnackbar(item) {
      if (!item) {
        item = i18n.t('message.navDrawer.successMessage')
      }
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: item,
      })
    },
    async handleConfirm() {
      this.isFetching = true
      await this.tryPaymentAgain()
      this.isFetching = false
    },
    handleClose() {
      this.open = null
    },
    getLocale() {
      if (this.$i18next.resolvedLanguage === 'en') return 'en-US'
      return 'pt-BR'
    },
    getDateThroughTimeStamp(date) {
      const currentDate = date
      let locale = this.getLocale()
      let options = {
        month: '2-digit',
        year: '2-digit',
        day: '2-digit',
      }
      return String(
        new Date(currentDate).toLocaleString(locale, options).slice(0, 3) +
          new Date(currentDate).toLocaleString(locale, options).slice(3, 6) +
          new Date(currentDate).toLocaleString(locale, options).slice(6, 10)
      )
    },
  },
}
</script>
<style>
.cardTitle {
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
}
.paymentText {
  font-size: 16px;
  font-weight: 500;
  line-height: 150%; /* 24px */
  @media only screen and (max-width: 960px) {
    font-size: 13px !important;
  }
}
.dateText {
  font-size: 12px;
  font-weight: 400;
  line-height: 150%; /* 18px */
  @media only screen and (max-width: 960px) {
    font-size: 10px !important;
  }
}
</style>
